const nestedProperty = (_obj, _fullKey) => {
    if (!_fullKey || !_obj) {
        return undefined;
    }

    return _fullKey
        .replace(/\[(\w+)\]/g, ".$1") // convert indexes to properties
        .replace(/^\./, "") // strip a leading dot
        .split(".") // split
        .reduce((obj, prop) => (prop in obj ? obj[prop] : undefined), _obj);
};

export default nestedProperty;
